import { ADMIN_API_PREFIX, API_PREFIX } from './constant'
import { Request } from './request'

export function getSelectAiSettings(): Request {
  return {
    url: `${API_PREFIX}/blade-reminder/aisettings/selectAiSettings`,
    method: 'GET',
  }
}


export interface SaveAiSettingParams {
  businessTypes?: any
  type?: any
  value?: any
}

export function getSaveAiSettings(body: any): Request {
  return {
    url: `${API_PREFIX}/blade-reminder/aisettings/saveAiSettings`,
    method: 'POST',
    body
  }
}
